class BrevoNewsletter extends HTMLElement {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.message = this.querySelector('[data-newsletter-message]');
    this.button = this.querySelector('button[type="submit"]');
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.handleSubmit);
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.submitting || !this.form.reportValidity()) return;

    this.submitting = true;
    this.button.disabled = true;
    this.form.setAttribute('aria-busy', 'true');
    this.message.hidden = true;
    this.message.textContent = '';
    this.message.classList.remove('newsletter-form__message--success');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);

    try {
      const url = new URL(this.form.action);
      url.searchParams.set('isAjax', '1');
      const response = await fetch(url, {
        method: 'POST',
        body: new FormData(this.form),
        signal: controller.signal,
      });
      const result = await response.json();
      const success = response.ok && result.success === true;
      const fieldErrors = Object.values(result.errors || {}).flat().filter((error) => typeof error === 'string');
      const fallback = success
        ? 'Your subscription has been successful.'
        : 'Your subscription could not be saved. Please try again.';
      // Brevo can return HTML in its messages; display only its text.
      const content = new DOMParser().parseFromString(
        typeof result.message === 'string' && result.message ? result.message : fieldErrors.join(' ') || fallback,
        'text/html'
      );
      this.message.textContent = content.body.textContent.trim() || fallback;
      this.message.classList.toggle('newsletter-form__message--success', success);
      if (success) this.form.reset();
    } catch (error) {
      this.message.textContent = 'Unable to confirm your subscription. Please try again.';
    } finally {
      clearTimeout(timeout);
      this.message.hidden = false;
      this.form.removeAttribute('aria-busy');
      this.button.disabled = false;
      this.submitting = false;
    }
  }
}

if (!customElements.get('brevo-newsletter')) {
  customElements.define('brevo-newsletter', BrevoNewsletter);
}
